export type CloudUserRole = 'super_admin' | 'admin' | 'user';

export function isStaffRole(role?: CloudUserRole | null): boolean {
  return role === 'super_admin' || role === 'admin';
}

export function isSuperAdminRole(role?: CloudUserRole | null): boolean {
  return role === 'super_admin';
}

export function roleLabel(role?: CloudUserRole | null): string {
  if (role === 'super_admin') return '超级管理员';
  if (role === 'admin') return '管理员';
  return '普通用户';
}
